import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { IconPlay } from "@/components/icons";

import { cn } from "@/utils/cn.ts";

interface EpisodeCardProps {
  link: string;
  episode: number;
  duration: number;
  viewed?: number;
  image: string;
}

const EpisodeCard = ({ link, episode, viewed, image, duration }: EpisodeCardProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className={"space-y-[1.125rem]"}>
      <Link to={link} className={cn("group/card relative block overflow-hidden rounded-xl")}>
        <div className="relative">
          <img
            src={
              image ||
              "https://cdn.splay.uz/media/contents_meta/suschestvo-kyonsona11/images/trailer_picture_1.resized.jpg"
            }
            alt={"video"}
            loading={"lazy"}
            className={"aspect-video w-full object-cover object-center"}
          />
          {viewed && duration && (
            <div className="absolute bottom-0 left-[0.625rem] right-[0.625rem] h-[0.1875rem] rounded-md bg-white/20">
              <div className="h-full rounded-md bg-primary" style={{ width: (viewed / duration) * 100 + "%" }}></div>
            </div>
          )}
        </div>

        <span
          className={
            "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform rounded-full bg-orange-1 p-3 opacity-0 transition-opacity group-hover/card:opacity-100"
          }
        >
          <IconPlay className={"size-6 fill-white"} />
        </span>
      </Link>
      <p className={"mt-2 flex items-center justify-between"}>
        <span className={"text-xl/normal font-medium text-on-primary max-lg:text-base/normal"}>
          {t("General.episode-value", { value: episode })}
        </span>
        <span className={"text-lg/normal text-[#FFFFFFCC] max-lg:text-sm/normal"}>23:20</span>
      </p>
    </div>
  );
};

export default EpisodeCard;
